import React, { Component } from "react";
import Table from '../../../../../components/table';
import { connect } from "react-redux";
import {
    ACTIONS_PLAYER, getPlayerConditionBatter,
    convertPlayerConditionBatter,
    convertPlayerConditionBatterRightLeft,
    convertPlayerConditionBatterCount,
    convertPlayerConditionBatterStadium,
    convertPlayerConditionBatterCommon
} from './../../../../../actions/player-condition-batter';
import Loading from "../../../../../components/loading";
import moment from 'moment';

class BatterContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataBatterTable1: [],
            dataBatterTable2: [],
            dataBatterTable3: [],
            dataBatterTable4: [],
            dataBatterTable5: [],
            dataBatterTable6: [],
            dataBatterTable7: [],
            dataBatterTable8: [],
            dataBatterTable9: [],
            dataBatterTable10: [],
            dataBatterTable11: [],
            showLoading: false,
            centralLeague: [],
            pacificLeague: []
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.response) {
            if (nextProps.status === ACTIONS_PLAYER.GET_PLAYER_CONDITION_BATTER_SUCCESS) {
                this.setState({
                    showLoading: false,
                    dataBatterTable1: convertPlayerConditionBatter(nextProps.response.central_league),
                    centralLeague: nextProps.response.central_league,
                    dataBatterTable2: convertPlayerConditionBatter(nextProps.response.pacific_league),
                    pacificLeague: nextProps.response.pacific_league,
                    dataBatterTable3: convertPlayerConditionBatter(nextProps.response.monthly),
                    dataBatterTable4: convertPlayerConditionBatterRightLeft(nextProps.response['right.left']),
                    dataBatterTable5: convertPlayerConditionBatterCommon(nextProps.response.count),
                    dataBatterTable6: convertPlayerConditionBatterCount(nextProps.response.runners_on),
                    dataBatterTable7: convertPlayerConditionBatterStadium(nextProps.response.stadium),
                    dataBatterTable8 : convertPlayerConditionBatterCommon(nextProps.response['fast_or_breaking_ball']),
                    dataBatterTable9 : convertPlayerConditionBatterCommon(nextProps.response['course.lr']),
                    dataBatterTable10: convertPlayerConditionBatterCommon(nextProps.response['course.hl']),
                    dataBatterTable11: convertPlayerConditionBatterCommon(nextProps.response['scene.innings']),

                })
            }
        }
        if (this.props.tab && nextProps.tab === 'batter' && (this.props.tab !== 'batter' || nextProps.date_from !== this.props.date_from || nextProps.date_to !== this.props.date_to)) {
            this.setState({showLoading: true});
            this.props.getPlayerConditionBatter(nextProps.id, moment(nextProps.date_from).format('YYYY/MM/DD'), moment(nextProps.date_to).format('YYYY/MM/DD'));
        }

    }

    redirectToOpponentTeam(id) {
        this.props.history.push(`/team-report/${id}`);
    }

    render() {
        return (
            <div>
                <Table header={this.props.headerBatterTable1} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable1} isShowOptionTable={false} titleTable={this.props.titleBatterTable1} onRowClick={(data, index) => {this.redirectToOpponentTeam(this.state.centralLeague[index].opponent_team_id)}} />
                <Table header={this.props.headerBatterTable2} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable2} isShowOptionTable={false} titleTable={this.props.titleBatterTable2} onRowClick={(data, index) => {this.redirectToOpponentTeam(this.state.pacificLeague[index].opponent_team_id)}} />
                <Table header={this.props.headerBatterTable3} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable3} isShowOptionTable={false} titleTable={this.props.titleBatterTable3} />
                <Table header={this.props.headerBatterTable4} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable4} isShowOptionTable={false} titleTable={this.props.titleBatterTable4} />
                <Table header={this.props.headerBatterTable5} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable5} isShowOptionTable={false} titleTable={this.props.titleBatterTable5} />
                <Table header={this.props.headerBatterTable6} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable6} isShowOptionTable={false} titleTable={this.props.titleBatterTable6} defaultValue={'-'} />
                <Table header={this.props.headerBatterTable8} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable8} isShowOptionTable={false} titleTable={this.props.titleBatterTable8} defaultValue={'-'} />
                <Table header={this.props.headerBatterTable9} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable9} isShowOptionTable={false} titleTable={this.props.titleBatterTable9} defaultValue={'-'} />
                <Table header={this.props.headerBatterTable10} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable10} isShowOptionTable={false} titleTable={this.props.titleBatterTable10} defaultValue={'-'} />
                <Table header={this.props.headerBatterTable11} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable11} isShowOptionTable={false} titleTable={this.props.titleBatterTable11} defaultValue={'-'} />
                <Table header={this.props.headerBatterTable7} showPagination={false} showCheckbox={false} showSearch={false} itemOfPage={this.state.dataBatterTable7} isShowOptionTable={false} titleTable={this.props.titleBatterTable7} />
                <Loading show={this.state.showLoading} />
            </div>
        )
    }
}



const mapStateToProps = ({ players }) => {
    return {
        headerBatterTable1: players.headerBatterTable1,
        headerBatterTable2: players.headerBatterTable2,
        headerBatterTable3: players.headerBatterTable3,
        headerBatterTable4: players.headerBatterTable4,
        headerBatterTable5: players.headerBatterTable5,
        headerBatterTable6: players.headerBatterTable6,
        headerBatterTable7: players.headerBatterTable7,
        headerBatterTable8: players.headerBatterTable8,
        headerBatterTable9: players.headerBatterTable9,
        headerBatterTable10: players.headerBatterTable10,
        headerBatterTable11: players.headerBatterTable11,
        dataBatterTable1: players.dataBatterTable1,
        dataBatterTable2: players.dataBatterTable2,
        dataBatterTable3: players.dataBatterTable3,
        dataBatterTable4: players.dataBatterTable4,
        dataBatterTable5: players.dataBatterTable5,
        dataBatterTable6: players.dataBatterTable6,
        dataBatterTable7: players.dataBatterTable7,
        titleBatterTable1: players.titleBatterTable1,
        titleBatterTable2: players.titleBatterTable2,
        titleBatterTable3: players.titleBatterTable3,
        titleBatterTable4: players.titleBatterTable4,
        titleBatterTable5: players.titleBatterTable5,
        titleBatterTable6: players.titleBatterTable6,
        titleBatterTable7: players.titleBatterTable7,
        titleBatterTable8: players.titleBatterTable8,
        titleBatterTable9: players.titleBatterTable9,
        titleBatterTable10: players.titleBatterTable10,
        titleBatterTable11: players.titleBatterTable11,
        response: players.response ,
        status: players.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getPlayerConditionBatter: (playerId, datePickerFrom, datePickerTo) => {
            dispatch(getPlayerConditionBatter(playerId, datePickerFrom, datePickerTo));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BatterContent);